import { Download, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { CLIENT_GUIDE } from "@/lib/manual";
import { buildManualPdf } from "@/lib/manualPdf";
import { useI18n } from "@/lib/i18n";
import { SectionHeading } from "@/components/Brand";

const WHATSAPP = "17879388834";

export default function ClientGuide() {
  const { t, lang, path } = useI18n();
  const g = CLIENT_GUIDE[lang] || CLIENT_GUIDE.es;

  return (
    <div className="mx-auto max-w-[1100px] px-4 py-14 sm:px-8 lg:px-12 lg:py-20" data-testid="guide-page">
      <SectionHeading label={t("brand.positioning")} title={g.title} sub={g.subtitle} />

      <p className="mt-8 max-w-3xl text-sm text-[#5A5752]" data-testid="guide-intro">{g.intro}</p>

      <div className="mt-8 flex flex-wrap gap-3">
        <button
          type="button"
          data-testid="guide-download-pdf"
          onClick={() => buildManualPdf(g).save(lang === "en" ? "HR-Creations-Client-Guide.pdf" : "HR-Creations-Guia-para-Clientes.pdf")}
          className="inline-flex min-h-[48px] items-center gap-2 border border-[#8F3329] bg-[#8F3329] px-6 text-sm text-[#FAFAF7] transition-colors duration-300 hover:bg-[#252525]"
        >
          <Download size={15} /> {t("guide.pdf")}
        </button>
        <Link
          to={path("prints")}
          data-testid="guide-prints-link"
          className="inline-flex min-h-[48px] items-center gap-2 border border-[#C69A3B] px-6 text-sm text-[#8F3329] transition-colors duration-300 hover:bg-[#C69A3B]/15"
        >
          {t("nav.prints")}
        </Link>
        <a
          href={`https://wa.me/${WHATSAPP}`}
          target="_blank"
          rel="noreferrer"
          data-testid="guide-whatsapp"
          className="inline-flex min-h-[48px] items-center gap-2 border border-[#C69A3B] px-6 text-sm text-[#8F3329] transition-colors duration-300 hover:bg-[#C69A3B]/15"
        >
          <MessageCircle size={15} /> WhatsApp
        </a>
      </div>

      <div className="mt-12 space-y-10" data-testid="guide-sections">
        {g.sections.map((sec, idx) => (
          <section key={sec.id} data-testid={`guide-section-${sec.id}`} className="border-l-2 border-[#C69A3B]/50 pl-6">
            <p className="label-mono text-[#C69A3B]">{String(idx + 1).padStart(2, "0")}</p>
            <h2 className="mt-2 font-serif-display text-2xl text-[#8F3329]">{sec.title}</h2>
            <ul className="mt-4 space-y-3">
              {sec.steps.map((step, i) => (
                <li key={i} className="text-sm text-[#5A5752]">{step}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
